module.exports = __webpack_public_path__ + "media/tick3.be73bd42.webm";